import React, { useState } from "react";
import { FiChevronsDown, FiChevronsUp } from "react-icons/fi";
import { Tooltip } from "@mui/material";

import {
  convertSecondsToHMS,
  convertToUTCString,
} from "../../../../utils/helpers/helper";
import LeadIntegrations from "./LeadIntegrations";
import { useSelector } from "react-redux";
import { useFunctionalityAccess } from "../../../../core/common/wrapper/HasFunctionalityAccess";

const LeadDetailsSidebar = ({ leadData: lead }) => {
  const [openAccordion, setOpenAccordion] = useState(true);
  const toggleAccordion = () => {
    setOpenAccordion(!openAccordion);
  };

  const hasZoomAccess = useFunctionalityAccess("zoomSetting");

  return (
    <div className="col-12 theiaStickySidebar">
      <div className="card">
        <div className="card-body p-3">
          <div className="">
            {/* Status Information */}
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Status
              </h6>
              <Tooltip
                title={openAccordion ? "Collapse Details" : "Expand Details"}
              >
                <div style={{ cursor: "pointer" }} onClick={toggleAccordion}>
                  {openAccordion ? (
                    <FiChevronsUp size={18} />
                  ) : (
                    <FiChevronsDown size={18} />
                  )}
                </div>
              </Tooltip>
            </div>
          </div>

          <div className="row mb-2">
            {lead?.currentStatus?.name && (
              <div className="d-flex justify-content-between col-md-6">
                <span className="col-6 fw-bold">Current Status:</span>
                <span className="col-6 text-capitalize">
                  {lead?.currentStatus?.name}
                </span>
              </div>
            )}
            <div className="d-flex justify-content-between col-md-6">
              <span className="col-6 text-capitalize fw-bold">
                Probability:
              </span>
              <span className="col-6 text-capitalize">
                {lead?.probability || "N/A"}
              </span>
            </div>
          </div>
          <hr />

          {openAccordion && (
            <>
              {hasZoomAccess && (
                <>
                  {/* Zoom webinar */}
                  <div className="d-flex align-items-center gap-2 mb-1">
                    <h5 className=" fw-semibold fs-5 text-decoration-underline mb-1">
                      Zoom Webinar
                    </h5>

                    {lead?.meetingDetails &&
                      lead?.meetingStatus === "attended" && (
                        <span className="fw-italic fw-semibold">
                          <em>
                            (
                            <span>
                              Attended Zoom for:{" "}
                              {convertSecondsToHMS(
                                lead?.meetingDetails?.duration
                              )}
                            </span>
                            {" | "}
                            <span>
                              Joined at:{" "}
                              {convertToUTCString(
                                lead?.meetingDetails?.joinTime
                              )}
                            </span>
                            {" | "}
                            <span>
                              Left at:{" "}
                              {convertToUTCString(
                                lead?.meetingDetails?.leaveTime
                              )}
                            </span>
                            )
                          </em>
                        </span>
                      )}
                  </div>
                  <LeadIntegrations lead={lead} />
                  <hr />
                </>
              )}

              {/* Interested Product */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Interested Product
              </h6>
              <div className="row mb-2 ">
                <div className="d-flex justify-content-between col-md-6">
                  <span className="col-6 fw-bold">Product Category:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.productCategory || lead?.productCategory || "N/A"}
                  </span>
                </div>
                <div className="d-flex justify-content-between col-md-6">
                  <span className="col-6 fw-bold">Product Name:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.productInterested?.name ||
                      lead?.productInterested ||
                      "N/A"}
                  </span>
                </div>
              </div>
              <hr />

              {/* Additional Information */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Additional Information
              </h6>
              <ul className="row mb-3">
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Lead Source:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.leadSource || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Question 1:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.question1 || "N/A"}
                  </span>
                </li>

                <li className="d-flex justify-content-between mb-1 col-md-6">
                  <span className="col-6 fw-bold">Reference Source:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceSource || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Question 2:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.question2 || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Business Type:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.businessType || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Question 3:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.question3 || "N/A"}
                  </span>
                </li>
              </ul>

              <ul className="row mb-3">
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Alternate Phone Number:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.alternateNumber || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Client Code:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.clientCode || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Company:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.ofCompany?.name || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Lead Assigned To:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.assignedTo?.name || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Last Modified:</span>
                  <span className="col-6">
                    {convertToUTCString(lead?.lastActivityDate) || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Last Modified By:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.lastUpdationBy?.name || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Occupation:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.occupation || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Preferred Language:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.language || "N/A"}
                  </span>
                </li>
              </ul>

              <ul className="row mb-3">
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Reference Source:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceSource || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Code:
                  </span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceByFranchiseCode || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Mobile:
                  </span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceByFranchiseMobile || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Email:
                  </span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceByFranchiseEmail || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Name:
                  </span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceByFranchiseName || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Franchise Details:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.franchiseDetails || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Franchise RM:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.franchiseRM || "N/A"}
                  </span>
                </li>
              </ul>

              {/* Additional Information */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Marketing Information
              </h6>
              <ul className="row mb-3">
                {/* UTM fields */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Medium:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.utmMedium || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Source:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.utmSource || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Content:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.utmContent || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Term:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.utmTerm || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Campaign:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.utmCampaign || "N/A"}
                  </span>
                </li>

                {/* Other marketing info */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Data Sources:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.dataSources || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">IP Address:</span>
                  <span className="col-6">{lead?.ipAddress || "N/A"}</span>
                </li>

                {/* Social/Ads info */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Account:</span>
                  <span className="col-6">{lead?.adAccount || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Campaign:</span>
                  <span className="col-6">{lead?.adCampaign || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Set:</span>
                  <span className="col-6">{lead?.adSet || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ads:</span>
                  <span className="col-6">{lead?.ads || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Lead Form:</span>
                  <span className="col-6">{lead?.leadForm || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Facebook Page:</span>
                  <span className="col-6">{lead?.facebookPage || "N/A"}</span>
                </li>

                {/* IDs */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Account ID:</span>
                  <span className="col-6">{lead?.adAccountId || "N/A"}</span>
                </li>
                 <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ads Name:</span>
                  <span className="col-6">{lead?.adsName || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Campaign Name:</span>
                  <span className="col-6">{lead?.campaignName || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Campaign ID:</span>
                  <span className="col-6">{lead?.adCampaignId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Set ID:</span>
                  <span className="col-6">{lead?.adSetId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad ID:</span>
                  <span className="col-6">{lead?.adId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Lead Form ID:</span>
                  <span className="col-6">{lead?.leadFormId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Facebook Page ID:</span>
                  <span className="col-6">{lead?.facebookPageId || "N/A"}</span>
                </li>

                {/* Extra business/social fields */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Brand:</span>
                  <span className="col-6">{lead?.brand || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Lead ID (Social):</span>
                  <span className="col-6">{lead?.leadIdSocial || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Business Lead Type:</span>
                  <span className="col-6">
                    {lead?.businessLeadType || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Platform:</span>
                  <span className="col-6">{lead?.platform || "N/A"}</span>
                </li>
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadDetailsSidebar;
